import React from 'react';
import Navbar from '../components/Navbars/AppNavbar.js';
import Footer from '../components/Footers/Footer.js';
import FooterSM from '../components/Footers/FooterSmall.js';
import DiscoverContainer from '../components/Discover/index';
import { getDocs, collection, query, where } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../config/firebaseFirestore';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

export default function Discover({ alpaarr }) {
  const SEO = {
    title: 'MusicArt | Discover',
    discription: 'Type your keywords',
    canonical: 'https://musicart.io/discover',
  };

  return (
    <>
      <NextSeo {...SEO} />
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        {/* <Link  rel="canonical" href="https://musicart.io/discover" /> */}
      </Head>
      <Navbar transparent />
      <DiscoverContainer alpaarr={alpaarr} />
      <Footer />
      <FooterSM />
    </>
  );
}

export async function getStaticProps() {
  let dataArr = [];
  const roomData = await getDocs(
    query(
      collection(firebaseFireStore, 'roomDetails'),
      where('isActive', '==', true),
    ),
  );
  roomData.forEach((x) => {
    dataArr.push({ ...x.data(), id: x.id });
  });
  let alpaarr = dataArr.sort(function (a, b) {
    if (a.RoomName.toLowerCase() < b.RoomName.toLowerCase()) {
      return -1;
    }
    if (a.RoomName.toLowerCase() > b.RoomName.toLowerCase()) {
      return 1;
    }
    return 0;
  });
  return { props: { alpaarr }, revalidate: 60 };
}
